import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrganizationProject } from "Api/organizations/projects/getOrganizationProject.request";
import { OrganizationProject } from "Api/organizations/projects/OrganizationProjects.types";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";

import type { AsyncThunkOptionType } from "Reducers/types";

export const getProject = createAsyncThunk<
  OrganizationProject,
  { organizationId: string; projectId: string },
  AsyncThunkOptionType
>(
  "app/organization/get_project",
  async ({ organizationId, projectId }, { rejectWithValue, getState }) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId: organizationId
      });

      if (!organization) {
        return rejectWithValue("Organization does not exit");
      }

      const project = await getOrganizationProject(organization.id, projectId);

      return project;
    } catch (err: unknown) {
      const status = (err as { code?: number; status?: number })?.code;
      // Don't log the realistic 4xx outcomes (typo'd URL, no access) — they
      // belong to the error boundary, not the bug log.
      if (![400, 403, 404].includes(status ?? 0)) {
        logger(err, {
          action: "get_organization_project",
          organizationId
        });
      }

      return rejectWithValue(err);
    }
  }
);
